<template>
	<div>
		<ly-login v-ref:login v-if="!isLogin"></ly-login>
		<ly-home v-if="isLogin"></ly-home>
	</div>
</template>
<script>
	var Common = require("./utils/Common.js");
	/**
	* 当前VM对象
	*/
	var VM = {
		timer : null,//定时器
		inter : null,//
		comp : null,//当前组件对象
		/**
		* 获取是否登录
		*/
		loginStatus : function(){
			var val = Common.getCookie();
			// console.log(val + " > " + new Date().getTime() + " = " + (val - new Date().getTime()) + " now:" + new Date());
			if(val && val > new Date().getTime()){
				return true;
			}else{
				return false;
			}
		},
		/**
		* cookie的监听与控制
		*/ 
		cookieWatch : function(){		
			//定时器，勇于检查当前登陆的状态
			VM.inter = setInterval(function(){
				if(!VM.loginStatus()){//检查到退出登录
					VM.clearLoginStatus();//退出登录的处理
				}
			},1000);
			//启用cookie的更新操作
			VM.updateExp();
		},
		/**
		* 更新cookie的过期时间
		*/
		updateExp : function(){
			if(VM.timer){clearTimeout(VM.timer);}			
			var val = Common.getCookie();//获得cookie中的值
			var time = new Date().getTime();//当前时间戳
			var diff = val - time - 2000;//提前两秒更新
			diff = diff < 1 ? 1 : diff;		
			// console.log(new Date() +  " -- " + diff + " 后更新cookie");	
			VM.timer = setTimeout(function(){
				// console.log("当前更新时间:" + new Date());
				Common.setCookie();//更新Cookie的内容
				VM.updateExp();//递归调用自己
			},diff);
		},
		/**
		* 清除记录登录状态的各种东东
		*/
		clearLoginStatus : function(){
			VM.comp.isLogin = false;//设置未登录状态
			localStorage.removeItem('remenber_on');//移除自动登录的标识
			if(this.inter){clearInterval(this.inter)};
			if(this.timer){clearTimeout(this.timer)};
			Common.setCookie(-100000);//设置cookie过期
		}
	};
	/**
	* 当前组件对象
	*/
	module.exports = {
		data : function () {
			return {
				isLogin : false, //标识是否登录
			}
		},
		components : {
			'ly-login' :  require('./views/Login.vue'),
			'ly-home' :  require('./views/Home.vue'),
		},
		ready: function() {	
			VM.comp = this;
			//判断是否是当前会话
			if(VM.loginStatus() || this.$refs.login.readAccount()) {
				this.isLogin = true;
				Common.setCookie();//cookie存储值标识
				VM.cookieWatch();//设置cookie的监听
			}			
		},
		events : {
			/**
			* 登录的监听
			*/
			login : function(bool){
				this.isLogin = bool;
				Common.setCookie();//cookie存储值标识
				VM.cookieWatch();//设置cookie的监听
			},
			/**
			* 退出登录
			*/
			loginOut : function(){
				VM.clearLoginStatus();//清空登录状态
			}
		}
	}
</script>


/** WEBPACK FOOTER **
 ** app.vue?709996d6
 **/